<template>
  <v-menu
    :value="value"
    absolute
    :position-x="x"
    :position-y="y"
    :close-on-click="true"
    :close-on-content-click="true"
    @input="$emit('input', $event)"
  >
    <v-list>
      <v-list-item v-for="(item, index) in items" :key="index" @click="item.method">
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import uk from '../langs/contextMenu/uk.json'
import ru from '../langs/contextMenu/ru.json'
import en from '../langs/contextMenu/en.json'

import { recursiveChangeWidgetId } from '../tools/recursiveChangeWidgetId'
export default {
  name: 'widgets-context-menu',
  props: {
    value: Boolean,
    x: Number,
    y: Number,
    snippetCreatable: {
      type: Boolean,
      default: true
    },
    // Текущий виджет, на котором произошел вызов контекстного меню
    widgetModel: {
      type: Object
    }
  },
  computed: {
    items: function () {

      let menu = []
      menu.push({ title: this.$t('contextMenu.remove'), method: () => this.$emit('deleteComponent', this.widgetModel) })
      menu.push({ title: this.$t('contextMenu.copy'), method: () => { this.$store.commit('setCopiedWidget', this.widgetModel) } })
      // контейнер текущего виджета
      let widgets = this.widgetModel?.Widgets || this.widgetModel?.Rows || this.widgetModel?.Columns
      // является ли текущий контейнер массивом, если да то, добавляем кнопку "ВСТАВИТЬ"
      if (Array.isArray(widgets)) {
        menu.push({ 
          title: this.$t('contextMenu.paste'), method: () => {
            let widget = JSON.parse(JSON.stringify(this.$store.getters.getCopyWidget))
            if (!widget) {
              return
            }
            var newCopyWidget = recursiveChangeWidgetId(widget)
            this.$emit('pasteCopiedWidget', newCopyWidget)
          }
        })
      }
      
      if (this.snippetCreatable) {
        menu.push({
          title: this.$t('contextMenu.createSnippet'),
          method: () => this.$emit('createSnippet')
        })
      }
      return menu
    }
  },
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  }
}
</script>

<style scoped>
</style>
